import styled from 'styled-components';

export const HeaderRegionName = styled.div`
margin-top: 1rem;
font-size: 38px;
color: var(--primary);
text-align: center;
margin-bottom: 1rem
`;

export const AssetName = styled.div`
.MuiTypography-body1 {
    font-family: "Segoe UI", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
}
`;

export const StyledLoader = styled.div`
`;

export const RadionButtons = styled.div`
`;

export const RadionAndImageWrapper = styled.div`
display: flex;
justify-content: space-between;
`;

export const DisclaimarText = styled.p`
margin: 5px;
font-size: 12px;
font-weight: 550;
color: #ea7c34;
`;
